import { createFileRoute } from "@tanstack/react-router";
import { ReferralsLayout } from "#/features/referrals/components/referrals-layout";

export const Route = createFileRoute("/_app/referrals")({
	component: ReferralsLayout,
});
